export const selectModal = ({ state: { modal } }) => ({ modal });
export const selectModalStack = ({ modal }) => modal.get('stack');
